import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const SUBJECT = 'subject'
const GRADE_THRESHOLD = 'grade_threshold'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
      required: true,
    },
    [GRADE_THRESHOLD]: {
      label: `${t('risk.grade-risk-threshold')}`,
      name: GRADE_THRESHOLD,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SUBJECT]: '',
  [GRADE_THRESHOLD]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [SUBJECT]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('required-error-message')}`),
      })
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GRADE_THRESHOLD]: yup.number().required(`${t('errors.required-error-message')}`),
  })

export default formModel
